const authDetails = state => {
  return state;
};

export default {
  authDetails
};
